import formatCurrency from "../../utils/currency-formatter";

export default class SavedCars {
    constructor(parent) {
        this.parent = parent;
        this.myAccount = window?.HONDA?.MyAccount;
        
        this.configuredCarWrapper = parent.el.querySelector('.configured-car-link-wrapper');
        if(this.configuredCarWrapper) {
            this.configuredCarLink = this.configuredCarWrapper.querySelector('a');
            this.configuredCar();
        }
        
        this.savedCarsWrapper = parent.el.querySelector('.saved-cars-link-wrapper');
        if(this.savedCarsWrapper) {
            this.savedCarsList = this.savedCarsWrapper.querySelector('ul');
            this.savedCarsImage = this.savedCarsWrapper.querySelector('picture img');
            this.savedCarsCount = this.savedCarsWrapper.querySelector('sup');
            this.savedCarsTemplate = _.template(parent.el.querySelector('#saved-cars-template').innerHTML.replaceAll('\\', ''));
            this.savedCars();
        } 
    }

    configuredCar() {
        if(this.configuredCarWrapper) {
            const configCarItems = JSON.parse(localStorage.getItem("configCarItems") || "{}");
            const pageUrl = configCarItems?.pageUrl;
            const shortUrl = configCarItems?.shortUrl;
           
            if(pageUrl && shortUrl){
                this.configuredCarWrapper.style.display = 'block';
                this.configuredCarLink.href = pageUrl + shortUrl;
            }            
        } else {
            this.configuredCarWrapper.style.display = 'none';
        }
    }

    async savedCars() {
        if(this.savedCarsWrapper && this?.myAccount?.isLoggedIn()) {
            const result = await this.myAccount.query('offers');
            const offers = result?.data?.me?.offers?.filter((offer) => offer.type === 'HondaCarConfiguratorOffer');
            if (offers && offers.length > 0) {
                offers.forEach((offer) => {
                    offer.image = this.savedCarImage(offer);
                    offer.price = HONDA?.currency ? formatCurrency(offer.totalAmount, true) : '';
                });
                this.savedCarsCount.textContent = `(${offers.length})`;
                this.savedCarsImage.src = offers[0].image;
                this.savedCarsList.innerHTML = this.savedCarsTemplate({ offers });                
                this.savedCarsWrapper.style.display = 'block';
            } else {
                this.savedCarsWrapper.style.display = 'none';
            }
        } else {
            this.savedCarsWrapper.style.display = 'none';
        }
    }

    secondaryLink() {
        
    }

    savedCarImage(offer){
        return `/content/dam/futureretail/models/${offer.vehicleCode}/colour/${offer.vehicleColourCode}/${this.capitalizeFirstLetter(offer.vehicleCode)}-${offer.vehicleColourCode}-f34-env.png/_jcr_content/renditions/small.png`;
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}